import React from 'react';
import { Popover } from 'antd';

const FloatingProgress = ({ current, total, history = [] }) => {
    const percentage = Math.round((current / total) * 100);

    const content = (
        <div className='border-[3px] rounded border-[var(--color-brand)] p-[15px] max-h-[60vh] overflow-y-auto max-w-xs'>
            <p className='brand-font text-[20px] font-semibold mb-[10px] text-[var(--color-brand)]'>
                Progress: {current} / {total}
            </p>
            {history.length > 0 && (
                <>
                    <p className='brand-font text-[16px] font-semibold mb-[5px] text-[var(--color-subtext)]'>
                        Your Answers:
                    </p>
                    <ul className="space-y-3">
                        {history.map((item, index) => (
                            <li key={index} className='bg-gray-50 p-2 rounded'>
                                <p className='brand-text text-[14px] font-semibold line-clamp-2'>{item.question}</p>
                                <p className='brand-text text-[14px] text-[var(--color-brand)] mt-1'>{item.answer}</p>
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );

    return (
        <Popover content={content} trigger="click" placement="topRight">
            <button
                className="fixed bottom-16 left-2 w-16 h-16 bg-white border-dashed border-[var(--color-highlight)] border-[3px] text-xl font-bold rounded-full flex items-center justify-center z-50 shadow-lg text-[var(--color-subtext)] hover:scale-110 transition-transform duration-300"
            >
                {percentage}%
            </button>
        </Popover>
    );
};

export default FloatingProgress;
